export default __webpack_public_path__ + "static/twitter-fd436806a4b8dd84080519f5c4f5ab54.png";